
import Storage from "@/utils/storage";
import { mergeByKey } from "@/utils/helper";
import ChatService from "@/services/ChatService";
const chat = {
  namespaced: true,
  state: () => ({
    currentPlayer: {},
    isShowWindowChat: false,
    requestChat: {},
    recentFriends: Storage.get("recentFriends", "[]"),
    maximumChatBox: 4,
    maximumActiveChat: 8,
    friends: [],
    activeChats: [],
    friendsDate: null,
    openedChatBoxes: [],
    conversationMap: {},
    showListFriend: 'false'
  }),
  getters: {
  },
  mutations: {
    SET_RECENT_FRIENDS(state, item) {
      let recent = mergeByKey(state.recentFriends, item, 'id')
      state.recentFriends = recent.map(x => {
        return {
          id: x.id,
          name: x.name,
          picture: x.picture,
          isOnline: x.isOnline,
          notify: x.notify
        }
      }).slice(0, 3)
      Storage.set('recentFriends', JSON.stringify(state.recentFriends));
    },
    UPDATE_RECENT_FRIENDS(state, item) {
      state.recentFriends = [...item];
      Storage.set('recentFriends', JSON.stringify(state.recentFriends));
    },
    SET_IS_SHOW_WINDOW_CHAT(state, val){
      state.isShowWindowChat = val
    },
    SET_REQUEST_CHAT(state, val){
      state.requestChat = val
    },
    mutateChatState(state, payload) {
      Object.keys(payload).forEach(key => {
        state[key] = payload[key]
      })
    },
    commitFriend(state, friend) {
      let friendIndex = state.friends.findIndex(f => f.user.id === friend.user.id)
      if(friendIndex === -1) {
        state.friends.push(friend)
      } else {
        state.friends[friendIndex] = friend
      }
      state.friends = Object.assign([], state.friends)
    },
    removeFriend(state, friendId) {
      let friendIndex = state.friends.findIndex(f => f.user.id === friendId)
      if(friendIndex !== -1) {
        state.friends.splice(friendIndex, 1)
      }
    },
    commitMessage(state, payload) {
      
      if(!state.conversationMap[payload.friendId]) {
        state.conversationMap[payload.friendId] = []
      }
      if(payload.messages) {
        const conversation = Object.assign([], state.conversationMap[payload.friendId])
        payload.messages.forEach(message => {
          const index = conversation.findIndex(m => m[1] === message[1])
          if(index !== -1) {
            conversation[index] = message
          } else {
            conversation.push(message)
          }
        })
        state.conversationMap[payload.friendId] = conversation
      }
    },
    commitShowListFriend(state, show) {
      state.showListFriend = show
    },
    flushMessageFromLocal(state, friendId) {
      
      if(!state.conversationMap[friendId]) {
        state.conversationMap[friendId] = []
      }
      if(state.conversationMap[friendId].length === 0) {
        return
      }
      const orphanMessages = state
                              .conversationMap[friendId]
                              .filter(message => message && !message[4])
      state.conversationMap[friendId] = orphanMessages
      
    },
  },
  actions: {
    async requestFriend({state, rootState, commit}, data) {
      const result = await ChatService.requestFriend(data);
      if(result.error) {
        return result
      }
      commit('commitFriend', result.myFriend)
      rootState.toggle.ChatFixedBottom.sendData({
        type: 'commitFriend',
        payload: result.theirFriend
      }, data.friend)
      return true
    },
    setRecentFriends({commit}, data){
      commit('SET_RECENT_FRIENDS', [data])
    },
    
    async getFriends({state, commit, dispatch}, data) {
      state.friendsDate = Date.now()
      const friends = await ChatService.getFriends();
      state.friends = friends.list
      state.friends.forEach(friend => {
        if(friend.lastMessage == 'Sent you a friend request'
          && !friend.readMessage
        ) {
          dispatch('openChatBox', friend.user.id)
        }
      })
      console.log('get friend done', friends.list.length)
    },
    
    openChatBox({state, dispatch, commit}, userId) {
      let openedChatBoxes = state.openedChatBoxes
      if(!Array.isArray(state.openedChatBoxes)) {
        state.openedChatBoxes = []
      }
      const index = state.openedChatBoxes.indexOf(userId);
      if(index !== -1) return
      state.openedChatBoxes.push(userId);
      if(state.openedChatBoxes.length > state.maximumChatBox) {
        state.openedChatBoxes.shift()
      }
      dispatch('addActiveChat', userId)
    },
    hideChatBox({state, commit}, userId) {
      const index = state.openedChatBoxes.indexOf(userId)
      if(index !== -1) {
        state.openedChatBoxes.splice(index, 1)
      }
    },
    addActiveChat({state, commit}, userId) {
      let activeChats = state.activeChats
      if(!Array.isArray(state.activeChats)) {
        state.activeChats = [];
      }
      const index = state.activeChats.indexOf(userId);
      if(index !== -1) return
      state.activeChats.push(userId);
      if(state.activeChats.length > state.maximumActiveChat) {
        state.activeChats.shift()
      }
    },
    removeActiveChat({state, commit, dispatch}, userId) {
      if(!Array.isArray(state.activeChats)) {
        state.activeChats = [];
      }
      const index = state.activeChats.indexOf(userId);
      if(index === -1) return;
      
      state.activeChats.splice(index, 1);
      dispatch('hideChatBox', userId)
    },
  },
};

export default chat;
